import { Table, TablePaginationConfig, TableProps } from "antd";
import React, { useMemo, useState } from "react";
import { useGetEmittedTitleDocumentsQuery } from "../../../redux/api/reconciliationsApiSlice";
import { EmittedTitleDocument } from "../../../types/reconciliation";
import dayjs from "dayjs";

export default function ArrearsTable() {

  const [pagination, setPagination] = useState<TablePaginationConfig>({
    current: 1,
    pageSize: 10,
    showTotal: (total, range) => `${range[0]}-${range[1]} di ${total} file`,
    onChange: (page, pageSize) => setPagination(prevPag => ({ ...prevPag, current: page, pageSize }))
  });
  const { data, isFetching, isUninitialized } = useGetEmittedTitleDocumentsQuery({
    page: pagination.current,
    page_size: pagination.pageSize
  });
  const loading = isUninitialized || isFetching;
  const columns: TableProps<EmittedTitleDocument>["columns"] = useMemo(() => [
    {
      key: "name",
      dataIndex: "name",
      title: "Nome file"
    },
    {
      title: "Data di creazione",
      dataIndex: "date_creation",
      key: "date_creation",
      render: (value) => dayjs(value).format("DD-MM-YYYY HH:mm")
    }
  ], []);

  return (<Table
    <EmittedTitleDocument>
    loading={loading}
    rowKey={"name"}
    pagination={{
      ...pagination,
      total: data?.count
    }}
    scroll={{ x: true }}
    columns={columns}
    dataSource={data?.results}
  />);
}